import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.css';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import generateStore from './app/redux/store';
import Bugsnag from './Bugsnag';

const { store, persistor } = generateStore();
const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

